import { createFileRoute } from '@tanstack/react-router';

import { AccountBillingPage } from '@/pages/account-billing/account-billing-page';

export const Route = createFileRoute('/account/billing')({
  component: AccountBillingRoute,
});

function AccountBillingRoute() {
  return <AccountBillingPage />;
}
